import React from 'react';
import { FaUserCheck, FaUserTimes, FaEnvelope } from 'react-icons/fa';
import './StaffManagement.css';
import { useRoster } from './hooks/useRoster';

const StaffManagement = () => {
  const { activeStaff, benchedStaff, benchStaff, activateStaff } = useRoster();

  const getStatusClass = (status) => {
    switch (status) {
      case 'active': return 'badge-default';
      case 'benched': return 'badge-secondary';
      case 'unavailable': return 'badge-danger';
      default: return 'badge-outline';
    }
  };

  const StaffCard = ({ staff, actions }) => (
    <div className="staff-card">
      <div className="staff-card-body">
        <div className="staff-avatar staff-avatar-color">
          {staff.name.split(' ').map(n => n[0]).join('')}
        </div>
        <div className="staff-details">
          <div className="staff-name-row">
            <h4 className="staff-name">{staff.name}</h4>
            <span className={`staff-badge ${getStatusClass(staff.status)}`}>
              {staff.status}
            </span>
          </div>
          <p className="staff-position">{staff.position}</p>
          <p className="staff-position">{staff.department}</p>
          <div className="staff-contact">
            <FaEnvelope className="icon-small" />
            <span>{staff.email}</span>
          </div>
          <div className="staff-skills">
            {staff.skills.map(skill => (
              <span key={skill} className="skill-badge">
                {skill}
              </span>
            ))}
          </div>
          {actions && (
            actions
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="staff-management-container space-y-6">
      <div>
        <div className="cards-staff">
          <div>
            <h2 className="cards-title">
              <FaUserCheck style={{ color: "#16a34a" }} className="icon" />
              Active Staff ({activeStaff.length})
            </h2>
          </div>
          <div className="staff-cards-content">
            {activeStaff.length > 0 ? (
              <div className="grid two-cols gap-4">
                {activeStaff.map(st => (
                  <StaffCard
                    key={st.id}
                    staff={st}
                    actions={
                      <button
                        className="bttn-outline"
                        onClick={() => benchStaff(st.id)}
                        style={{ width: "10rem" }}
                      >
                        <FaUserTimes className="icon-small mr-2" />
                        Move to Bench
                      </button>
                    }
                  />
                ))}
              </div>
            ) : (
              <p className="empty-message">
                No active staff members
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="separator" />

      {/* Benched Staff */}
      <div>
        <div className="cards-staff">
          <div>
            <h2 className="cards-title">
              <FaUserCheck className="icon" />
              Benched Staff ({benchedStaff.length})
            </h2>
          </div>
          <div className="staff-cards-content">
            {benchedStaff.length > 0 ? (
              <div className="grid two-cols gap-4">
                {benchedStaff.map(st => (
                  <StaffCard
                    key={st.id}
                    staff={st}
                    actions={
                      <button
                        className="activate-btn"
                        onClick={() => activateStaff(st.id)}
                        style={{ width: "10rem" }}
                      >
                        <FaUserCheck className="icon-small mr-2" />
                        Activate
                      </button>
                    }
                  />
                ))}
              </div>
            ) : (
              <p className="empty-message">
                No benched staff members
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffManagement;
